import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import {
  AlertWrapper, AlertTitle, AlertSubtitle, AlertBody,
} from './css';
import TextWithBold from '../../../utils/TextWithBold';
import SvgIcon from '../icons/SvgIcon';
import { endpoints } from '../../../utils/constants';

const Alert = (props) => {
  const { type, visible, currencyCode } = props;

  if (visible && type === 'credit-card-payment-instructions') {
    const linkLabel = t('ClickHere');
    const linkUrl = (currencyCode === 'US') ? endpoints.shipping.paymentUrlForUS : endpoints.shipping.paymentUrl;

    return (
      <AlertWrapper>
        <AlertTitle>
          <SvgIcon icon="CCIcon" />
          <span>{t('CCInstructionsTitle')}</span>
          <a href={linkUrl} target="_blank" rel="noopener noreferrer">
            {linkLabel.toLowerCase()}
          </a>
          <SvgIcon icon="ChevronRightIcon" />
        </AlertTitle>

        <AlertBody hasIcon>
          <AlertSubtitle>{t('CCInstructionsSubtitle')}</AlertSubtitle>
          <ul>
            <li><TextWithBold text={t('CCInstructionsLine1')} /></li>
            <li><TextWithBold text={t('CCInstructionsLine2')} /></li>
            <li><TextWithBold text={t('CCInstructionsLine3')} /></li>
          </ul>
        </AlertBody>

      </AlertWrapper>
    );
  }

  return null;
};

Alert.propTypes = {
  type: PropTypes.string,
  visible: PropTypes.bool,
  currencyCode: PropTypes.string,
};

export default Alert;
